"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badge = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var badge = {
  colors: {
    primary: {
      backgroundColor: _colors.colors.blue,
      backgroundColorHoverFocus: _colors.colors.blueHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    secondary: {
      backgroundColor: _colors.colors.gray,
      backgroundColorHoverFocus: _colors.colors.grayHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    success: {
      backgroundColor: _colors.colors.green,
      backgroundColorHoverFocus: _colors.colors.greenHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    danger: {
      backgroundColor: _colors.colors.red,
      backgroundColorHoverFocus: _colors.colors.redHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    warning: {
      backgroundColor: _colors.colors.yellow,
      backgroundColorHoverFocus: _colors.colors.yellowHoverFocus,
      color: _colors.colors.gray900,
      linkColor: _colors.colors.gray900
    },
    info: {
      backgroundColor: _colors.colors.cyan,
      backgroundColorHoverFocus: _colors.colors.cyanHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    light: {
      backgroundColor: _colors.colors.gray100,
      backgroundColorHoverFocus: _colors.colors.gray100HoverFocus,
      color: _colors.colors.gray900,
      linkColor: _colors.colors.gray900
    },
    dark: {
      backgroundColor: _colors.colors.gray800,
      backgroundColorHoverFocus: _colors.colors.gray800HoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    },
    default: {
      backgroundColor: _colors.colors.gray,
      backgroundColorHoverFocus: _colors.colors.grayHoverFocus,
      color: _colors.colors.white,
      linkColor: _colors.colors.white
    }
  },
  padding: {
    pill: '0.25rem 0.6rem',
    default: '0.25rem 0.4rem'
  },
  fontWeight: {
    default: '700'
  },
  borderRadius: _utils.utils.borderRadius
};
exports.badge = badge;